import CONSTANTS from 'tradera-constants/state';
import { DEFAULT_COOKIES } from 'tradera-constants/cookies';
import cookieUtil from 'tradera-utils/cookie';
import { cache, CACHE_KEYS } from 'tradera-utils/cache';
import { WEB_PUSH_MODAL_TYPES } from 'tradera-constants/push-notifications';

export default initData => {
    const { hasSearch } = initData;
    const itemLayout =
        cookieUtil.readCookie(DEFAULT_COOKIES['ITEM_LAYOUT'].key) ||
        DEFAULT_COOKIES['ITEM_LAYOUT'].default;
    const systemMessages = cache.read(CACHE_KEYS.SYSTEM_MESSAGES) || {};
    const messagingBadges = cache.read(CACHE_KEYS.MESSAGING_BADGES) || {
        threads: 0,
        threadsUnread: 0
    };

    return {
        systemMessages: {
            BankAccountMissing: false,
            InvoiceOverdue: false,
            InvoiceUnpaid: false,
            PayoutFailed: false,
            PayoutReadyBankAccountMissing: false,
            SwishNumberMissing: false,
            ...systemMessages
        },
        badges: {
            messaging: messagingBadges,
            system: 0
        },
        hasSearch,
        itemLayout: itemLayout,
        messagingModal: {
            open: CONSTANTS.MODAL.CLOSED,
            title: '',
            src: '',
            participating: false,
            recipientId: '',
            item: null
        },
        notificationOptinModal: {
            open: CONSTANTS.MODAL.CLOSED,
            type: WEB_PUSH_MODAL_TYPES.default
        },
        quickView: {
            open: CONSTANTS.MODAL.CLOSED,
            items: {},
            itemIds: [],
            currentItem: 0
        },
        videoModal: {
            open: CONSTANTS.MODAL.CLOSED,
            video: ''
        },
        profileMenu: { open: CONSTANTS.MODAL.CLOSED, redirectUrl: false },
        categoryDropdownMenu: { open: CONSTANTS.MODAL.CLOSED },
        showSearchForm: hasSearch,
        itemSettings: {
            open: CONSTANTS.MODAL.CLOSED,
            item: {},
            numberOfItemsOnDisplay: 0
        }
    };
};
